var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_flexcol _px-2 _py-3",
      attrs: { "data-qa": `updates-feed-card:${_vm.projectUpdateID}` },
    },
    [
      _c(
        "a",
        {
          staticClass: "gfu-bt--caption _tc--light _mb-2",
          attrs: {
            href: _vm.projectUrl,
            title: _vm.projectName,
            "data-qa": "project-name-link",
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.projectName) + "\n    ")]
      ),
      _vm._v(" "),
      _c("backer-center-header", {
        scopedSlots: _vm._u(
          [
            _vm.effectiveImageUrl
              ? {
                  key: "prefix",
                  fn: function () {
                    return [
                      _c("backer-center-thumbnail", {
                        attrs: {
                          "image-url": _vm.effectiveImageUrl,
                          name: _vm.projectName,
                          size: _vm.avatarSize,
                          url: _vm.projectUpdateUrl,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "base-text",
                    {
                      staticClass: "_tc--dark _line-clamp-2",
                      attrs: {
                        as: "a",
                        href: _vm.projectUpdateUrl,
                        level: "b1",
                        title: _vm.title,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.title) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.hasAbstract
                    ? _c(
                        "base-text",
                        {
                          staticClass: "_my-1 _tc--base",
                          attrs: { as: "div", level: "caption" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.abstract) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "_flex _gap-1 gfu-bt--caption _tc--light" },
                    [
                      _c(
                        "div",
                        [
                          _c("base-icon", { attrs: { name: "thumbs-up" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.likesCount))]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("•")]),
                      _vm._v(" "),
                      _c("notification-delivery-time", {
                        attrs: { timestamp: _vm.publishedAt },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }